import type { AgentCursor } from "@/stores/canvas-store";
import { agentCursorDisplayStatus } from "./agent-cursor-display-status";

/** A pointer presentation is still playing (finishPresentedCursor clears target and narration) or owns an active guide. */
export function isCursorPresenting(cursor: AgentCursor, activeGuideId: string | null): boolean {
  if (!cursor.presentationDeliveryId) return false;
  return Boolean(
    cursor.pointTarget ||
      cursor.presentationNarration ||
      cursor.presentationDeliveryId === activeGuideId,
  );
}

export function canDismissCursorTerminalStatus(
  cursor: AgentCursor,
  activeGuideId: string | null,
): boolean {
  const status = agentCursorDisplayStatus(cursor, true);
  return !!(
    !isCursorPresenting(cursor, activeGuideId) &&
    !status.question &&
    (status.error || (cursor.frozen && (status.content || status.contentFull)))
  );
}
